"use client"

import { NftsToBuyMoleculeReatom } from "@/app/nft/buy/nfts-to-buy/molecule.reatom"
import { useUserOwnedNft } from "@/app/nft/hooks/use-user-owned-nft"
import { BuyButtonReatom as BuyButton } from "@/app/nft/order/widget/actions/buy.reatom"
import { SDKNFTScope } from "@/app/sdk/anaconda-sdk-scope"
import { isExternalListing } from "@anaconda/core/nft/listing-source"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { ScopeProvider, useMolecule } from "bunshi/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { useCollection } from "../store/use-collection"
import { BuyCollectionButtonContent } from "./buy-collection-content-button"
import { BuySelectedItemsButton } from "./buy-selected-items-button"
import { useNftWithFloorPrice } from "./use-nft-with-flor-price"

export const BuyCollectionItemsView = reatomComponent(() => {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={<Skeleton className="h-9 w-[210px]" />}>
        <BuyCollectionItemsButton />
      </Suspense>
    </ErrorBoundary>
  )
}, "BuyCollectionItemsView")

export const BuyCollectionItemsButton = reatomComponent(() => {
  const nftWithFloorPrice = useNftWithFloorPrice()
  const { userOwnedNft } = useUserOwnedNft({ owner: nftWithFloorPrice?.owner })
  const { selectedNftsTotalPrice } = useMolecule(NftsToBuyMoleculeReatom)
  const totalPrice = selectedNftsTotalPrice()
  const collection = useCollection()

  const floorPrice = nftWithFloorPrice?.price
  const isPossibleToBuyFloor =
    floorPrice &&
    !userOwnedNft &&
    !isExternalListing(nftWithFloorPrice?.listingSource)

  if (totalPrice) {
    return <BuySelectedItemsButton />
  }

  if (!isPossibleToBuyFloor) return null

  const collectionName = collection?.name || undefined

  return (
    <ScopeProvider scope={SDKNFTScope} value={nftWithFloorPrice}>
      <BuyButton
        className="bg-success/20 text-white text-xs hover:bg-success/40"
        nft={nftWithFloorPrice}
        collectionName={collectionName}
      >
        <BuyCollectionButtonContent price={floorPrice} />
      </BuyButton>
    </ScopeProvider>
  )
}, "BuyCollectionItemsButton")
